const AppFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer flex align-items-center justify-content-center">
      <span className="text-sm text-600">
        © {year} Interview portal. All Rights Reserved.
      </span>
      <img
        src="/images/saas-innova-arrow.png"
        alt="Company Logo"
        className="h-2rem"
      />
    </footer>
  );
};

export default AppFooter;
